module.exports = new __parcel__URL__("all-ticketsDark.5aecc647.svg").toString();